export const RECEIVED_CLUES = 'RECEIVED_CLUES';
export const CLEARED_CLUES = 'CLEARED_CLUES';
export const RECEIVED_QUESTIONS = 'RECEIVED_QUESTIONS';
export const CLEARED_QUESTIONS = 'CLEARED_QUESTIONS';
export const RECEIVED_VISITOR = 'RECEIVED_VISITOR';
export const CLEARED_VISITOR = 'CLEARED_VISITOR';
